import React from 'react'

export const LoadingAnimation: React.FC = () => {
  return (
    <div>
      <div className="flex flex-row bg-clouds items-center rounded-[1rem] p-4 mt-4">
        <div className="bg-white rounded-[.5rem] mr-[1rem] w-[120px] h-[120px] flex items-center justify-center  md:w-[60px] lg:w-[120px]" />
        <div className="flex flex-col grow">
          <div className="w-1/3 h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
        </div>
      </div>
      <div className="flex flex-row bg-clouds items-center rounded-[1rem] p-4 mt-4">
        <div className="bg-white rounded-[.5rem] mr-[1rem] w-[120px] h-[120px] flex items-center justify-center  md:w-[60px] lg:w-[120px]" />
        <div className="flex flex-col grow">
          <div className="w-1/3 h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
        </div>
      </div>
      <div className="flex flex-row bg-clouds items-center rounded-[1rem] p-4 mt-4">
        <div className="bg-white rounded-[.5rem] mr-[1rem] w-[120px] h-[120px] flex items-center justify-center  md:w-[60px] lg:w-[120px]" />
        <div className="flex flex-col grow">
          <div className="w-1/3 h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
          <div className="w-full h-[24px] bg-white rounded-[1rem] m-1"></div>
        </div>
      </div>
    </div>
  )
}
